// AUTO-GENERATED from markdown-golden.1.bin — do not edit by hand.
// Canonical blank-markdown Loro "golden" snapshot, inlined as a byte literal so
// it can be imported directly in any runtime (Cloudflare Worker, node, browser)
// without a bundler-specific asset loader.
export const MARKDOWN_GOLDEN: Uint8Array = new Uint8Array([
  108, 111, 114, 111, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 57, 219, 202, 49,
  0, 3, 73, 1, 0, 0, 76, 79, 82, 79, 0, 0, 20, 0, 20, 1, 16, 1, 85, 238,
  63, 251, 131, 254, 148, 50, 1, 1, 0, 0, 0, 0, 0, 9, 1, 138, 150, 132, 162, 13,
  0, 1, 0, 26, 5, 4, 1, 0, 0, 22, 4, 0, 4, 0, 2, 4, 0, 0, 0, 4,
  4, 0, 0, 0, 18, 4, 0, 0, 0, 36, 81, 3, 105, 100, 115, 8, 99, 104, 105, 108,
  100, 114, 101, 110, 9, 100, 105, 114, 101, 99, 116, 105, 111, 110, 6, 102, 111, 114, 109, 97,
  116, 6, 105, 110, 100, 101, 110, 116, 4, 116, 121, 112, 101, 7, 118, 101, 114, 115, 105, 111,
  110, 1, 36, 2, 105, 100, 10, 116, 101, 120, 116, 70, 111, 114, 109, 97, 116, 9, 116, 101,
  120, 116, 83, 116, 121, 108, 101, 4, 114, 111, 111, 116, 0, 37, 1, 4, 15, 4, 0, 4,
  2, 12, 0, 7, 2, 1, 0, 3, 10, 0, 1, 8, 10, 5, 0, 2, 1, 20, 2, 1,
  15, 12, 2, 4, 1, 8, 38, 11, 2, 40, 1, 0, 63, 9, 4, 7, 1, 9, 0, 9,
  4, 0, 5, 0, 3, 0, 5, 9, 112, 97, 114, 97, 103, 114, 97, 112, 104, 3, 1, 9,
  0, 5, 8, 84, 115, 49, 103, 112, 108, 86, 53, 3, 0, 5, 0, 0, 5, 0, 3, 0,
  5, 4, 114, 111, 111, 116, 3, 1, 9, 0, 5, 4, 114, 111, 111, 116, 0, 2, 0, 102,
  114, 1, 213, 220, 255, 217, 191, 208, 191, 202, 50, 38, 0, 2, 0, 118, 118, 1, 213, 220,
  255, 217, 191, 208, 191, 202, 50, 40, 0, 0, 245, 0, 5, 1, 3, 0, 232, 108, 5, 82,
  1, 0, 0, 0, 5, 0, 0, 0, 12, 0, 50, 148, 254, 131, 251, 63, 238, 85, 0, 0,
  0, 0, 0, 2, 0, 118, 118, 31, 224, 82, 96, 38, 1, 0, 0, 165, 1, 0, 0, 76,
  79, 82, 79, 0, 4, 34, 77, 24, 96, 64, 130, 101, 1, 0, 0, 246, 45, 0, 3, 1,
  1, 213, 220, 255, 217, 191, 208, 191, 202, 50, 2, 3, 9, 6, 105, 110, 100, 101, 110, 116,
  3, 0, 6, 102, 111, 114, 109, 97, 116, 4, 0, 4, 116, 121, 112, 101, 4, 9, 112, 97,
  114, 97, 103, 114, 97, 112, 104, 8, 99, 104, 105, 108, 100, 114, 101, 110, 7, 57, 0, 247,
  1, 6, 3, 9, 116, 101, 120, 116, 83, 116, 121, 108, 101, 4, 0, 1, 36, 27, 0, 224,
  18, 1, 9, 100, 105, 114, 101, 99, 116, 105, 111, 110, 0, 10, 38, 0, 17, 70, 89, 0,
  247, 34, 3, 0, 7, 118, 101, 114, 115, 105, 111, 110, 3, 2, 0, 1, 85, 238, 63, 251,
  131, 254, 148, 50, 0, 9, 0, 3, 0, 4, 0, 5, 0, 6, 0, 11, 0, 12, 0, 7,
  0, 8, 9, 4, 0, 9, 0, 0, 0, 0, 4, 168, 0, 247, 1, 4, 1, 1, 2, 105,
  100, 4, 8, 84, 115, 49, 103, 112, 108, 86, 53, 64, 0, 80, 10, 9, 4, 0, 18, 48,
  0, 130, 2, 1, 0, 4, 114, 111, 111, 116, 43, 0, 1, 11, 0, 7, 39, 0, 84, 19,
  0, 13, 0, 4, 117, 0, 86, 1, 0, 0, 0, 4, 48, 0, 7, 189, 0, 37, 4, 1,
  154, 0, 240, 2, 4, 3, 2, 4, 0, 2, 0, 2, 2, 0, 2, 3, 2, 1, 0, 2,
  1, 50, 0, 104, 2, 0, 0, 2, 0, 0, 76, 0, 16, 3, 76, 0, 10, 172, 0, 49,
  0, 0, 4, 50, 0, 80, 0, 1, 2, 0, 1, 32, 0, 3, 54, 0, 51, 6, 0, 128,
  151, 0, 37, 0, 7, 119, 1, 15, 94, 1, 1, 34, 2, 3, 132, 1, 1, 46, 0, 9,
  93, 1, 24, 36, 93, 1, 5, 178, 1, 6, 89, 1, 85, 1, 3, 105, 100, 115, 195, 0,
  240, 15, 0, 18, 0, 1, 0, 13, 0, 14, 0, 0, 0, 15, 0, 16, 0, 17, 0, 0,
  161, 0, 209, 0, 248, 0, 68, 1, 122, 1, 6, 0, 0, 0, 0, 0, 127, 78, 93, 185,
  1, 0, 0, 0, 5, 0, 0, 0, 13, 0, 0, 85, 238, 63, 251, 131, 254, 148, 50, 2,
  0, 0, 0, 1, 6, 0, 128, 4, 114, 111, 111, 116, 37, 49, 91, 189, 125, 1, 0, 0,
  0, 0, 0, 0,
]);
